import {
  retry,
  timeout,
  request,
  hawkeEndpoint,
  HTTPError,
  TimeoutError,
  getJwtToken,
} from '@fingermarkglobal/request';
import { RestaurantMenuCount, ChromeSerialSettings } from '@fingermarkglobal/types';
import { isLocalUrl } from '../utils/is-local-url';

const getProductsRequest = async (count: RestaurantMenuCount, settings: ChromeSerialSettings) => {
  const organisationId = process.env.POI_APP_ORGANISATION_ID || null;

  const { storeId: id } = settings.settings.datasource;
  const { customRestaurantEndpoint = null } = settings.settings.labs || {};

  const endpoint = customRestaurantEndpoint || hawkeEndpoint;

  try {
    const token = await getJwtToken();

    const response = await request
      .get(`${endpoint}/menu/products/${organisationId}/${id}`, {
        retry,
        timeout,
        headers: {
          Authorization: `Bearer ${token}`,
          'x-api-apex-logging-project': process.env.POI_APP_LOGGER_PROJECT,
          'accept-encoding': 'gzip',
        },
        ...(isLocalUrl(endpoint) && { prefixUrl: '' }),
      })
      .json();

    const products = response;
    return products;
  } catch (err) {
    if (err instanceof HTTPError || err instanceof TimeoutError) throw err;
    logger.error('restaurant - getProductsRequest - error:', err);
    throw err;
  }
};

export { getProductsRequest };
